<style lang="less">
.carousel-catainer {
    height: 100%;
}
.carousel {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    .transition-group {
        display: inline-block;
        width: 100%;
        height: 100%;
        position: relative;
    }
    .fade-enter-active {
         transition: opacity .5s linear  1s;
    }
    .fade-leave-active {
        transition: opacity .5s linear;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .fade-enter-to, .fade-leave {
        opacity: 1;
    }
    &-item {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        &-img {
            height: 100%;
            max-height: 1500px;
        }
    }
    &-title {
      position: absolute;
      bottom: 198px;
      color: #FFFFFF;
      font-family: PingFang TC;
      font-style: normal;
      font-weight: 600;
      font-size: 32px;
      line-height: 42px;
    transition: color .5s linear  .5s;
    }
    &-points {
        z-index: 100;
        width: 88px;
        height: 32px;
        background: rgba(255, 255, 255, 0.3);
        backdrop-filter: blur(16px);
        border-radius: 16px;
        position: absolute;
        bottom: 140px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 13px;
        &-point {
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 8px;
            cursor: pointer;
        }
    }
}
</style>
<template>
    <div class="carousel-catainer">
        <div class="carousel">
            <transition-group name="fade" class="transition-group">
                <template v-for="video in videos">
                    <div class="carousel-item" :key="video.id" v-show="video.id===activeId">
                        <video
                            :id="'video-'+ video.id"
                            :src="video.url"
                            autoplay
                            muted
                            autobuffer
                            preload="auto"
                            class="carousel-item-img"
                        />
                    </div>
                </template>
            </transition-group>
            <h3 class="carousel-title" :style="{color: activeVideo.color}">{{ activeVideo.alt }}</h3>
            
            <div class="carousel-points">
                <template v-for="img in videos">
                    <span
                        @click="onClick(img.id)"
                        :key="img.id"
                        class="carousel-points-point"
                        :style="{
                            backgroundColor:
                                activeId === img.id
                                    ? 'white'
                                    : 'rgba(0,0,0,0.4)',
                        }"
                    />
                </template>
            </div>
        </div>
    </div>
</template>

<script>

import { platform } from '@gdesign/platform';
export default {
    name: "carousel",
    props: {
        activeId: {
            type: Number,
            required: true,
        },
    },
    mounted() {
        this.playCarousel();
    },
    computed: {
        activeVideo() {
            return this.videos.find((img) => img.id === this.activeId);
        },
        videos() {
            return [
                {
                    id: 1,
                    url:
                        "https://st0.dancf.com/csc/1681/configs/system/20210021-110338-ea07.mp4",
                    alt: "图片编辑器，一键裁剪",
                    time: 10,
                    color: '#ffffff',
                },
                {
                    id: 2,
                    url:
                        "https://st0.dancf.com/csc/1681/configs/system/20210021-110540-87b3.mp4",
                    alt: "图片编辑器，无损压缩",
                    time: 9,
                    color: '#ffffff',
                },
                {
                    id: 3,
                    url:
                        "https://st0.dancf.com/csc/1681/configs/system/20210021-110433-edae.mp4",
                    alt: "图片编辑器，轻松消除",
                    time: 7,
                    color: '#ffffff',
                },
                {
                    id: 4,
                    url:
                        "https://st0.dancf.com/csc/1681/configs/system/20210021-110555-88d2.mp4",
                    alt: "图片编辑器，批量处理",
                    time: 10,
                    color: '#33383E',
                },
            ];
        },
    },
    watch: {
        activeId: {
            immediate: true,
            handler() {
                this.playCarousel();
            },
        },
    },
    methods: {
        playCarousel() {
            if (platform.isMobile) {
                return;
            }
            clearTimeout(this.handler);
            this.$nextTick(() => {
                const video = document.querySelector(`#video-${this.activeId}`)
                video.currentTime = 1;
                video.play();
            })
            
            this.handler = setTimeout(() => {
                let value = this.activeId;
                if (this.activeId >= 4) {
                    value = 1;
                } else {
                    value += 1;
                }
                this.setActiveId(value);
            }, this.activeVideo.time * 1000);
        },
        onClick(id) {
            this.setActiveId(id);
        },
        setActiveId(value) {
            this.$emit("update:activeId", value);
        },
    },
};
</script>

<style lang="less" scoped></style>
